import Vue from "vue";
import { Plugin } from "vue-fragment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "./vue/config/validator";
import "./vue/config/components";
import { store } from "./vue/config/store";
import vClickOutside from "v-click-outside";

const vueBlackList = ["/challenge"];

if (!vueBlackList.includes(window.location.pathname)) {
  Vue.use(Plugin);
  Vue.component("ValidationProvider", ValidationProvider);
  Vue.component("ValidationObserver", ValidationObserver);
  Vue.use(vClickOutside);

  Vue.prototype.window = window;
  Vue.config.ignoredElements = ["klarna-placement"];

  if (!window.Shopify?.designMode) {
    // eslint-disable-next-line no-new
    new Vue({
      el: "#app",
      store,
    });

    window.__vueEnabled = true;
  }

  window.dispatchEvent(new CustomEvent("vue:configured"));
}
